export default "__VITE_ASSET__CkgR9GE1__"